import React, { Component, Fragment } from 'react';
import { Column } from 'react-virtualized';

import defaultRowRenderer from 'components/shared/ReactVirtualizedTable/DefaultRowRenderer';
import ReactVirtualizedTable from 'components/shared/ReactVirtualizedTable';
import { AmenityStatus } from 'components/shared/StatusHelper';
import { getTranslatedString } from 'helpers/i18n';

class AmenitiesTable extends Component {
  openAmenityDetails = (event, amenityId) => {
    if (event._dispatchListeners.length === 2) return;
    this.props.openAmenityInDrawer(amenityId);
  };

  handleRowClick = ({ rowData, event }) => {
    if (rowData.tableHeader) return;

    this.openAmenityDetails(event, rowData.id);
  };

  render() {
    const { data } = this.props;
    return (
      <Fragment>
        <ReactVirtualizedTable
          data={data}
          rowRenderer={defaultRowRenderer}
          onRowClick={this.handleRowClick}
          grouped
        >
          <Column
            width={70}
            label={getTranslatedString('landlordPortal.amenities.tableHeader.status')}
            dataKey="offline_status"
            cellRenderer={({ rowData }) => <AmenityStatus amenity={rowData} />}
          />
          <Column
            width={250}
            label={getTranslatedString('landlordPortal.amenities.tableHeader.name')}
            dataKey="name"
          />
          <Column
            width={200}
            label={getTranslatedString(`landlordPortal.amenities.tableHeader.type`)}
            dataKey="amenity_type_code"
            cellRenderer={({ rowData }) => {
              if (rowData && rowData.amenity_type_code) {
                return getTranslatedString(
                  `landlordPortal.amenities.form.amenity_type.${rowData.amenity_type_code}`
                );
              }
            }}
          />
        </ReactVirtualizedTable>
      </Fragment>
    );
  }
}

export default AmenitiesTable;
